export default __webpack_public_path__ + "static/media/microtica-text-logo.3a9ded05.svg";